/** Linha "titulo + descricao + switch", no estilo da aba Controle. */
export default function SwitchLinha({ titulo, descricao, ligado, onChange, disabled, testId }) {
  return (
    <div className={`flex items-center justify-between gap-3 p-3.5 bg-muted/40 rounded-lg ${disabled ? "opacity-60" : ""}`}>
      <div className="min-w-0">
        <div className="font-medium text-sm">{titulo}</div>
        {descricao && <div className="text-xs text-muted-foreground mt-0.5">{descricao}</div>}
      </div>
      <button type="button" onClick={() => !disabled && onChange(!ligado)} disabled={disabled} data-e2e={testId}
        aria-pressed={ligado} role="switch" aria-checked={ligado}
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${ligado ? "bg-primary" : "bg-gray-300 dark:bg-gray-600"}`}>
        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${ligado ? "translate-x-6" : "translate-x-1"}`} />
      </button>
    </div>
  );
}
